import React from 'react';

const PrematchList = ({ prematchMarkets }) => (
  <div className="table-responsive fix-odd">
    <table className="table-style table-style--setting">
      <thead><tr><th>Markets</th></tr></thead>
      <tbody>
        {prematchMarkets?.map((market) => (
          <tr key={`market-${market.id}`} className="table-style__row">
            <td>{market.name}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
export default PrematchList;
